import { FeatureFlagName } from '../interfaces/feature-flag.interface';

export const E2eFmeFlagMock: Partial<Record<FeatureFlagName, boolean>> = Object.freeze({
  [FeatureFlagName.odt2]: true,
  [FeatureFlagName.enableZtEarlyAccess]: false,
  [FeatureFlagName.mobileManualEvaluations]: true,
});
